<template>
  <div class="uploadFile">
    <!-- 上传区域：根据 styleType 渲染不同样式 -->
    <el-upload
      ref="upload"
      class="upload-btn"
      :action="''"
      :http-request="customUploadRequest"
      :before-upload="beforeUpload"
      :limit="prop.limit"
      :show-file-list="false"
      :file-list="uploadFileList"
      :multiple="prop.styleType !== 'single'"
      :accept="acceptTypes"
    >
      <!-- 按钮样式 -->
      <el-button
        :style="prop.style"
        v-if="prop.styleType == 'button'"
        ref="uploadBtn"
        :disabled="uploading"
      >
        <em class="iconfont iconannex"></em><span>{{ prop.buttonName }}</span>
      </el-button>
      <!-- 文本样式 -->
      <span
        class="font"
        :style="prop.style"
        v-if="prop.styleType == 'font'"
        ref="uploadBtn"
      >
        <em class="iconfont iconannex"></em><span>{{ prop.buttonName }}</span>
      </span>
      <!-- 头像/单图模式 -->
      <div
        class="singleBox"
        :style="prop.style"
        v-if="prop.styleType == 'single'"
      >
        <img
          v-if="singleUrl && thumbnail"
          :src="$utils.getFormat(singleUrl, 3)"
          class="single"
        />
        <img v-else-if="singleUrl" :src="singleUrl" class="single" />
        <i class="el-icon-plus" v-else></i>
      </div>
    </el-upload>

    <!-- 文件列表 -->
    <ul
      class="uploadFileList"
      v-show="
        uploadFileList && uploadFileList?.length && prop.styleType != 'single'
      "
    >
      <li v-for="(ff, fi) in uploadFileList" :key="'file_' + fi">
        <el-image :src="ff.ico" class="defaultImg"></el-image>
        <span class="fileName slh">{{ ff.name }}</span>
        <a @click="viewFile(ff)">预览</a>
        <el-divider direction="vertical"></el-divider>
        <a @click="removeFile(fi)">删除</a>
        <el-checkbox
          v-model="ff.checked"
          @change="uploadFileListChange"
          v-if="isChoose && from == 'AppDetail'"
          >{{ chooseName }}</el-checkbox
        >
      </li>
    </ul>

    <!-- 上传进度 -->
    <div v-if="uploading && uploadProgress > 0 && uploadProgress < 100" class="upload-progress">
      <el-progress
        :percentage="uploadProgress"
        :stroke-width="4"
        :show-text="false"
      ></el-progress>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import COS from "cos-js-sdk-v5";

export default {
  name: "g-uploadfile",
  props: {
    value: [Array, String],
    prop: {
      type: Object,
      default: () => ({
        fileDirType: "comp_img",
        limit: 10,
        buttonName: "点击上传",
        styleType: "button",
        style: "width:auto;height:34px;padding:0 10px;",
        field: {
          id: "attachId",
          name: "attachName",
          url: "attachUrl",
        },
      }),
    },
    thumbnail: {
      type: Boolean,
      default: false,
    },
    fileList: {
      type: Array,
      default: () => [],
    },
    noToken: {
      type: Object,
      default: () => ({
        isNose: false,
        userId: null,
        vipId: null,
      }),
    },
    from: String,
    isChoose: { type: Boolean, default: false },
    chooseName: String,
    acceptTypes: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapGetters("user", ["access_token"]),
    uploading() {
      return this.t_uploading;
    },
  },
  data() {
    return {
      t_uploading: false,
      uploadProgress: 0,
      uploadFileList: [],
      checked: [],
      singleUrl: null,
      cosInstance: null,
      currentUploadMap: {},
      // 内置 COS 配置（固定值）
      cosConfig: {
        bucket: "staffcloud-1312610724",
        region: "ap-beijing",
        tmpSecretId: "",
        tmpSecretKey: "",
        securityToken: "",
        startTime: 0,
        expiredTime: 0,
      },
      // 接口地址
      getStsUrl: "getStsCredential",
    };
  },
  watch: {
    value: {
      handler: function (newVal) {
        if (this.prop.styleType == "single" && newVal) {
          this.singleUrl = newVal;
        } else if (this.prop.styleType == "single" && !newVal) {
          this.singleUrl = "";
        } else if (this.prop.styleType != "single" && newVal?.length) {
          this.uploadFileList = [];
          newVal.forEach((ele) => {
            const url = ele[this.prop.field.url] || ele.url || ele;
            this.uploadFileList.push({
              name: ele[this.prop.field.name] || ele.name || "未知文件",
              url: url,
              ico: this.$utils?.getFormat ? this.$utils.getFormat(url, 2) : this.getFileIcon(url),
              checked: ele.checked || false,
            });
          });
        }
      },
      immediate: true,
    },
  },
  methods: {
    // ----- 获取文件图标 -----
    getFileIcon(url) {
      if (!url) return "";
      const ext = url.split(".").pop()?.toLowerCase() || "";
      const iconMap = {
        pdf: "https://cdn.jsdelivr.net/npm/pdf-icon@1.0.0/pdf.png",
        doc: "https://cdn.jsdelivr.net/npm/doc-icon@1.0.0/doc.png",
        docx: "https://cdn.jsdelivr.net/npm/doc-icon@1.0.0/doc.png",
        xls: "https://cdn.jsdelivr.net/npm/excel-icon@1.0.0/excel.png",
        xlsx: "https://cdn.jsdelivr.net/npm/excel-icon@1.0.0/excel.png",
        ppt: "https://cdn.jsdelivr.net/npm/ppt-icon@1.0.0/ppt.png",
        pptx: "https://cdn.jsdelivr.net/npm/ppt-icon@1.0.0/ppt.png",
        png: "https://cdn.jsdelivr.net/npm/image-icon@1.0.0/image.png",
        jpg: "https://cdn.jsdelivr.net/npm/image-icon@1.0.0/image.png",
        jpeg: "https://cdn.jsdelivr.net/npm/image-icon@1.0.0/image.png",
        gif: "https://cdn.jsdelivr.net/npm/image-icon@1.0.0/image.png",
        svg: "https://cdn.jsdelivr.net/npm/image-icon@1.0.0/image.png",
        mp4: "https://cdn.jsdelivr.net/npm/video-icon@1.0.0/video.png",
        avi: "https://cdn.jsdelivr.net/npm/video-icon@1.0.0/video.png",
        mov: "https://cdn.jsdelivr.net/npm/video-icon@1.0.0/video.png",
        zip: "https://cdn.jsdelivr.net/npm/zip-icon@1.0.0/zip.png",
        rar: "https://cdn.jsdelivr.net/npm/zip-icon@1.0.0/zip.png",
      };
      return iconMap[ext] || "";
    },

    // ----- 上传前校验 -----
    beforeUpload(file) {
      if (this.acceptTypes) {
        const acceptArr = this.acceptTypes.split(",").map((s) => s.trim());
        const fileType = file.type;
        const ext = "." + file.name.split(".").pop();
        const isValid = acceptArr.some((type) => {
          if (type.startsWith(".")) return ext.toLowerCase() === type.toLowerCase();
          return fileType === type || fileType.startsWith(type.replace("*", ""));
        });
        if (!isValid) {
          this.$message.error(`不支持的文件类型，仅支持 ${this.acceptTypes}`);
          return false;
        }
      }
      return true;
    },

    // ----- 自定义上传请求（直接上传至 COS） -----
    async customUploadRequest(options) {
      const { file, onProgress, onSuccess, onError } = options;
      this.t_uploading = true;
      this.uploadProgress = 0;
      console.log(file, "file")

      try {
        // 1. 获取临时密钥（从接口获取）
        const stsCredential = await this.getStsCredential({
          fileDirType: this.prop.fileDirType,
          fileName: file.name,
        });

        // 2. 初始化 COS 实例
        if (!this.cosInstance) {
          this.cosInstance = new COS({
            getAuthorization: (opt, callback) => {
              callback({
                TmpSecretId: stsCredential.TmpSecretId,
                TmpSecretKey: stsCredential.TmpSecretKey,
                SecurityToken: stsCredential.SecurityToken || stsCredential.Token,
                StartTime: stsCredential.StartTime || Math.floor(Date.now() / 1000),
                ExpiredTime: stsCredential.ExpiredTime || Math.floor(Date.now() / 1000) + 1800,
              });
            },
          });
        }

        // 3. 构建 COS 路径
        const bucket = stsCredential.Bucket || this.cosConfig.bucket;
        const region = stsCredential.Region || this.cosConfig.region;
        let cosKey = stsCredential.cosKey;

        if (!cosKey) {
          // 自动生成路径：fileDirType/日期/随机文件名
          const dir = this.prop.fileDirType || "default";
          const date = new Date().toISOString().slice(0, 10).replace(/-/g, "/");
          const ext = file.name.split(".").pop();
          const random = Date.now() + "_" + Math.random().toString(36).substring(2, 8);
          cosKey = `${dir}/${date}/${random}.${ext}`;
        }

        if (!bucket || !region) {
          throw new Error("缺少 Bucket 或 Region 配置");
        }

        // 4. 执行上传
        this.currentUploadMap[file.uid] = { name: file.name, cosKey };

        await new Promise((resolve, reject) => {
          this.cosInstance.putObject(
            {
              Bucket: bucket,
              Region: region,
              Key: cosKey,
              Body: file,
              onProgress: (progressData) => {
                const percent = Math.round(progressData.percent * 100);
                this.uploadProgress = percent;
                if (onProgress) onProgress(progressData);
              },
            },
            (err, data) => {
              if (err) {
                reject(err);
              } else {
                resolve(data);
              }
            }
          );
        });

        // 5. 上传成功
        const fileUrl = `https://${bucket}.cos.${region}.myqcloud.com/${cosKey}`;
        const result = {
          code: "200",
          data: {
            [file.name]: fileUrl,
          },
          _cosInfo: {
            bucket,
            region,
            cosKey,
            fileUrl,
          },
        };

        this.handleSuccess(result, file);

        onSuccess(result);
        this.t_uploading = false;
        this.uploadProgress = 0;
      } catch (error) {
        console.error("COS 上传失败:", error);
        this.$message.error("上传失败: " + (error.message || "未知错误"));
        onError(error);
        this.t_uploading = false;
        this.uploadProgress = 0;
      }
    },

    // ----- 获取临时密钥（从后端接口） -----
    async getStsCredential(params) {
      try {
        // 使用 axios 或 this.$http 调用接口
        const response = await this.$api[this.getStsUrl](params);
        // 兼容不同的返回格式
        const res = response.data || response;
        const data = res.data || res;

        // 如果接口返回的是 { success: true, data: { ... } } 格式
        const credential = data.data || data;

        return {
          TmpSecretId: credential.TmpSecretId || credential.secretId || credential.tmpSecretId,
          TmpSecretKey: credential.TmpSecretKey || credential.secretKey || credential.tmpSecretKey,
          SecurityToken: credential.SecurityToken || credential.Token || credential.token,
          Bucket: credential.Bucket || credential.bucket || this.cosConfig.bucket,
          Region: credential.Region || credential.region || this.cosConfig.region,
          cosKey: credential.cosKey || credential.coskey || "",
          StartTime: credential.StartTime || credential.startTime || Math.floor(Date.now() / 1000),
          ExpiredTime: credential.ExpiredTime || credential.expiredTime || Math.floor(Date.now() / 1000) + 1800,
        };
      } catch (error) {
        throw new Error("获取临时密钥失败: " + (error.message || "网络错误"));
      }
    },

    // ----- 附件上传成功 -----
    handleSuccess(res, file) {
      if (res.code == "200") {
        if (this.prop.styleType == "single") {
          this.uploadFileList = [];
          this.singleUrl = res.data[file.name];
        } else {
          this.uploadFileList.push({
            name: file.name,
            url: res.data[file.name],
            ico: this.$utils?.getFormat ? this.$utils.getFormat(res.data[file.name], 2) : "",
            checked: false,
          });
        }
        this.emitList();
      }
    },

    // ----- 预览文件 -----
    viewFile(ff) {
      if (!ff.url) return;
      if (this.$utils?.getFormat) {
        let str = this.$utils.getFormat(ff.url, 1);
        let title = this.$utils.safeTextToBase64 ? this.$utils.safeTextToBase64(ff.name) : encodeURIComponent(ff.name);
        str = str == "img" ? "" : (this.$utils.fileToHtml || "") + title;
        window.open(ff.url + str);
      } else {
        window.open(ff.url);
      }
    },

    // ----- 删除文件 -----
    removeFile(index) {
      this.uploadFileList.splice(index, 1);
      this.emitList();
    },

    // ----- 选择变化 -----
    uploadFileListChange() {
      let arr = [];
      this.checked = [];
      this.uploadFileList.forEach((e, i) => {
        if (e.checked) {
          arr.push(e);
          this.checked.push(i);
        }
      });
      this.$emit("evidence", arr);
      this.emitList();
    },

    // ----- 返回数据给父组件 -----
    emitList() {
      if (this.prop.styleType == "single") {
        this.$emit("input", this.singleUrl);
      } else {
        let arr = [];
        this.uploadFileList.forEach((ele, index) => {
          arr.push({
            [this.prop.field.id || "attachId"]: index + 1,
            [this.prop.field.name || "attachName"]: ele.name,
            [this.prop.field.url || "attachUrl"]: ele.url,
            checked: ele.checked || false,
          });
        });
        this.$emit("input", arr);
      }
    },

    // ----- 外部调用：清空文件 -----
    clearFiles() {
      this.uploadFileList = [];
      this.singleUrl = null;
      this.emitList();
    },
  },
};
</script>

<style lang="less" scoped>
.uploadFile {
  /deep/.el-upload {
    display: block;
    .iconannex {
      margin-right: 5px;
      font-size: unset;
    }
    .el-button {
      width: auto;
      height: 34px;
      padding: 0 12px;
      background-color: #fff;
      color: #606266;
      border-color: #e4e4e4;
    }
    .font {
      display: flex;
      align-items: center;
      font-size: 14px;
    }
    .singleBox {
      width: 60px;
      height: 60px;
      border: 1px solid #e4e4e4;
      border-radius: 2px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      .el-icon-plus {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        line-height: 1;
        font-size: 16px;
        color: #999;
      }
    }
  }
  .uploadFileList {
    margin-top: 10px;
    li {
      font-size: inherit;
      color: #999;
      display: flex;
      align-items: center;
      &:not(:first-child) {
        margin-top: 8px;
      }
      .defaultImg {
        width: 16px;
        height: 16px;
        overflow: hidden;
        margin-right: 8px;
        flex-shrink: 0;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .fileName {
        margin-right: 30px;
        word-break: break-all;
      }
      a {
        color: #409eff;
        font-size: 12px;
        flex-shrink: 0;
        cursor: pointer;
      }
      .el-divider {
        margin: 0 12px;
      }
      .el-checkbox {
        margin-left: 30px;
        font-size: 12px;
        align-items: center;
        .el-checkbox__label {
          line-height: 1;
        }
      }
    }
  }
  .upload-progress {
    margin-top: 8px;
    /deep/.el-progress {
      width: 100%;
      .el-progress-bar {
        padding-right: 0;
      }
    }
  }
}
</style>